import httpUtils from '../utils/http-utils';
import { API_PATH } from '../config/app-config';

// NMU-478: staff-intranet portal cards — /api/v1/admin/intranet
const SERVICE_NAME = API_PATH.INTRANET;

const searchBySection = (section) =>
    httpUtils.get(`${SERVICE_NAME}/cards?section=${encodeURIComponent(section)}`);

const getById = (id) => httpUtils.get(`${SERVICE_NAME}/cards/${encodeURIComponent(id)}`);

const add = (bean) => httpUtils.post(`${SERVICE_NAME}/cards`, bean);

const edit = (id, bean) => httpUtils.put(`${SERVICE_NAME}/cards/${encodeURIComponent(id)}`, bean);

const remove = (id) => httpUtils.del(`${SERVICE_NAME}/cards/${encodeURIComponent(id)}`);

const reorder = (section, orderedIds) =>
    httpUtils.put(`${SERVICE_NAME}/cards/reorder?section=${encodeURIComponent(section)}`, orderedIds);

// NMU-601: the Workspace & Shortcuts tabs themselves.
const listTabs = () => httpUtils.get(`${SERVICE_NAME}/tabs`);

const addTab = (bean) => httpUtils.post(`${SERVICE_NAME}/tabs`, bean);

const editTab = (id, bean) => httpUtils.put(`${SERVICE_NAME}/tabs/${encodeURIComponent(id)}`, bean);

const removeTab = (id) => httpUtils.del(`${SERVICE_NAME}/tabs/${encodeURIComponent(id)}`);

const intranetApi = { searchBySection, getById, add, edit, remove, reorder, listTabs, addTab, editTab, removeTab };

export default intranetApi;
